import { Autocomplete, InputAdornment, Paper, Stack, TextField, Button } from '@mui/material'
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from 'react-redux';
import { selectUserData } from '../../../../../features/userSlice';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import AddIcon from "@mui/icons-material/Add";
import { CheckPermissions } from '../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions';
import { setSelectedManualExpense } from '../../../../../features/manualExpenseSlice';
import AddNewExpense from '../ManualExpenseModals/AddNewExpense';
import { ManualExpenseFilterItems } from './ManualExpenseFilterItems';

const ManualExpenseFilterCard = () => {
  const dispatch = useDispatch();
  const userData = useSelector(selectUserData)
  const [searchParams, setSearchParams] = useSearchParams();
  const filteredManualExpense = useSelector((state: any) => state.manualExpense.filteredManualExpense);
  const selectedManualExpense = useSelector((state: any) => state.manualExpense.selectedManualExpense);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [, setIsThisAdd] = useState(false);

  const hasCreateManualExpansesPermission = CheckPermissions(
    userData?.data?.products?.finance,
    "providers_expenses",
    "create_manual_expenses"
  );

  useEffect(() => {
    // Update selectedManualExpense when searchParams change
    dispatch(setSelectedManualExpense(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  const handleAddClick = (_note: string) => {
    setIsThisAdd(true);
    setIsDialogOpen(true);
    setSearchParams((prevParams) => {
      const updatedParams = new URLSearchParams(prevParams);
      updatedParams.set("create", "true");
      return updatedParams;
    });
  }

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setIsThisAdd(false);
    dispatch(setSelectedManualExpense(null));
    setSearchParams((prevParams) => {
      const updatedParams = new URLSearchParams(prevParams);
      updatedParams.delete("create"); // Remove "create=true"
      updatedParams.delete("edit");
      updatedParams.delete("shareuid"); // Remove "edit=true"
      return updatedParams;
    });
  }

  const clearSelectedManualExpense = () => {
    dispatch(setSelectedManualExpense(null));
  }

  return (
    <>
      <Paper sx={{ padding: "0px", marginTop: "8px", boxShadow: "none" }}>
        <Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} gap={3} sx={{ paddingTop: "16px", paddingBottom: "16px" }}>
          <Autocomplete
            data-tracker="136"
            sx={{ width: "900px"}}
            disablePortal
            options={filteredManualExpense?.map((item: any) => item?.expense_name) || []}
            value={selectedManualExpense}
            onChange={(_, newValue) => {
              dispatch(setSelectedManualExpense(newValue));
              setSearchParams((prevParams) => {
                const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
                if (newValue) {
                  updatedParams.search = newValue; // Set new value
                } else {
                  delete updatedParams.search; // Remove from URL if cleared
                }
                return updatedParams;
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Expense Name"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
                color="secondary"
              />
            )}
            size="small"
          />
          <Stack flexDirection={"row"} justifyContent={"space-between"} sx={{ width: "100%" }} gap={2}>
            <ManualExpenseFilterItems clearSelectedManualExpense={clearSelectedManualExpense} />
            {hasCreateManualExpansesPermission ? (
              <Button
                variant="contained"
                color="secondary"
                endIcon={<AddIcon />}
                onClick={() => handleAddClick("")}
                data-tracker="212"
              >
                Add New Expense
              </Button>
            ) : (
              <Button
                variant="contained"
                color="secondary"
                disabled
                endIcon={<AddIcon />}
              >
                Add New Expense
              </Button>
            )}
          </Stack>
        </Stack>
      </Paper>
      <AddNewExpense open={isDialogOpen} handleClose={handleCloseDialog} />
    </>
  )
}

export default ManualExpenseFilterCard
